<div class="card my-3 shadow-sm">
  <div class="card-header bg-light d-flex align-items-center">
    <h3 class="card-title m-0">NDA Generator</h3>
  </div>

  <div class="card-body">
    @if (alertInfo.show) {
      <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false">
        {{ alertInfo.message }}
      </ngb-alert>
    }

    <p class="card-text text-muted">
      Generate the Non-Disclosure Agreement for this client.
    </p>

    <button
      type="button"
      class="btn btn-primary w-100"
      [disabled]="!canGenerate"
      (click)="generateNda()">
      @if (isGenerating) {
        <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span> Generating...
      } @else {
        <i class="fa fa-solid fa-file-contract me-1"></i> Download NDA
      }
    </button>
  </div>
</div>
